import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { IconButton } from 'lead-list/components/IconButton';
import { FC } from 'react';

interface PageHeadingProps {
  title?: string;
  onBackClick?: () => void;
  actions?: React.ReactNode;
}

export const PageHeading: FC<PageHeadingProps> = ({ title, onBackClick, actions }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%',
        marginBottom: '30px',
        minHeight: '18px',
        position: 'relative',
      }}
    >
      {!!onBackClick && (
        <IconButton
          ariaLabel="Go back"
          onClick={onBackClick}
          sx={{ position: 'absolute', left: 0 }}
        >
          <ArrowBackIcon />
        </IconButton>
      )}

      <Typography variant="h2" align="center">
        {title}
      </Typography>

      {!!actions && <Box sx={{ position: 'absolute', right: 0 }}>{actions}</Box>}
    </Box>
  );
};
